export default "__VITE_ASSET__0cd52f73__"